// existence.js
import React, { useEffect, useRef } from 'react';
import './Existence.css';
import Orb from '../effects/Orb/Orb';

export default function Existence() {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const text = textRef.current;

    const handleMouseMove = (e) => {
      const x = e.clientX / window.innerWidth;
      const y = e.clientY / window.innerHeight;
      
      container.style.setProperty('--mouse-x', x);
      container.style.setProperty('--mouse-y', y);
      
      text.style.transform = `translate(${(x - 0.5) * 20}px, ${(y - 0.5) * 20}px)`;
    };

    const handleFocus = () => {
      text.classList.add('focused');
    };

    const handleBlur = () => {
      text.classList.remove('focused');
    };

    window.addEventListener('mousemove', handleMouseMove);
    text.addEventListener('mouseenter', handleFocus);
    text.addEventListener('mouseleave', handleBlur);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      text.removeEventListener('mouseenter', handleFocus);
      text.removeEventListener('mouseleave', handleBlur);
    };
  }, []);

  return (
    <div className="existence-container" ref={containerRef}>
      <div className="layers">
        <div className="layer historical-layer"></div>
        <div className="layer cosmic-layer"></div>
        <div style={{ width: '100%', height: '100%', position: 'absolute' }}>
          <Orb
            hoverIntensity={0.5}
            rotateOnHover={true}
            hue={0}
            forceHoverState={false}
          />
        </div>
      </div>
      <div className="existence-text" ref={textRef} tabIndex="0">
        <p className="sanskrit">एक अस्तित्व जो प्रारंभ और अंत दोनों से परे है</p>
        <p className="english">An existence beyond both beginning and end —</p>
        <p className="dimension">unbound in the π/0 dimension, it is free.</p>
      </div>
    </div>
  );
}